import { render, staticRenderFns } from "./LeftBtn.vue?vue&type=template&id=15896976&scoped=true&"
import script from "./LeftBtn.vue?vue&type=script&lang=js&"
export * from "./LeftBtn.vue?vue&type=script&lang=js&"
import style0 from "./LeftBtn.vue?vue&type=style&index=0&id=15896976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15896976",
  null
  
)

export default component.exports